import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Tooltip,
} from "@material-ui/core";

import SingleLink from "../SingleLink";
import { Avatar, FlexboxGrid } from "rsuite";

class Financial extends Component {
  render() {
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={
            <Tooltip title="Financials" arrow placement="right">
              <Avatar circle size="sm" style={{ background: "#303f5e" }}>
                $
              </Avatar>
            </Tooltip>
          }
        >
          {this.props.open && <Typography>Financial</Typography>}
        </AccordionSummary>
        <AccordionDetails style={{ padding: 0, margin: 0 }}>
          <FlexboxGrid>
            <SingleLink
              page="/finance/payments"
              icon="money"
              title="All Payments"
              hdc={this.props.hdc}
            />
            <SingleLink
              page="/finance/warehousesummary"
              icon="cube"
              title="WH Summary"
              hdc={this.props.hdc}
            />
            <SingleLink
              page="/finance/clientbalance"
              icon="check2"
              title="Client Balance"
              hdc={this.props.hdc}
            />

            <SingleLink
              page="/finance/statistics"
              icon="line-chart"
              title="Statistics"
              hdc={this.props.hdc}
            />
          </FlexboxGrid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default withRouter(observer(Financial));
